import { stateRouter } from '@fno/service/global.js'

/*
 * This creates a loose cache for API requests.
 *
 * When you have a route where each node has a resolve that requires the
 * same resource, you end up with multiple calls to the same API endpoint.
 *
 * With this module, you will only make one API call per state change, and
 * on the next state change the cache will be cleared so you'll get a new
 * updated request.
 *
 * Use it like this:
 *
 *      import { api } from '@fno/service/global.js'
 *      import createCache from '@fno/lib/create-cache.js'
 *
 *      const myCache = createCache()
 *
 *      export const getSomeResource = async (params) => myCache(
 *          () => api.get('/path/to/api', params)
 *      )
 *
 */
export default () => {
    let cache
    const clear = () => {
        cache = null
    }
    stateRouter.on('stateChangeCancelled', clear)
    stateRouter.on('stateChangeEnd', clear)
    stateRouter.on('stateChangeError', clear)
    return callable => {
        if (!cache) {
            cache = callable()
        }
        return cache
    }
}
